export default {"src":"/_next/static/media/setting.b85a1e23.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};